import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { StatusBadge } from "@/components/site/Bits";

export default function ProjectCard({ p, large = false }) {
    return (
        <Link to={`/projects/${p.slug}`} data-testid={`project-card-${p.slug}`} className="group block">
            <div className={`img-zoom relative overflow-hidden rounded-2xl bg-forest ${large ? "aspect-[16/10]" : "aspect-[4/3]"}`}>
                {p.hero_image && <img src={p.hero_image} alt={`${p.title} — ${p.location}`} loading="lazy" className="h-full w-full object-cover" />}
                <div className="absolute inset-x-0 top-0 p-5 flex flex-wrap items-start justify-between gap-2">
                    <StatusBadge status={p.status} />
                </div>
            </div>
            <div className="pt-6 flex items-start justify-between gap-6">
                <div>
                    <p className="mono-label text-moss mb-2">{[p.location, p.type].filter(Boolean).join(" · ")}</p>
                    <h3 className={`font-serif text-forest leading-tight ${large ? "text-3xl md:text-4xl" : "text-2xl md:text-3xl"}`}>{p.title}</h3>
                    {p.program && <p className="mt-2 text-sm text-muted_text">{p.program}</p>}
                </div>
                <span className="mt-2 inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-forest/30 text-forest transition-colors group-hover:bg-forest group-hover:text-cream">
                    <ArrowRight className="h-4 w-4" />
                </span>
            </div>
        </Link>
    );
}
